import React, { useState } from "react";
import "./styles.scss";
import MusicUploaderIcon from "../../../../shared/Svg/MusicUploaderIcon";
import VideoUploaderIcon from "../../../../shared/Svg/VideoUploaderIcon";
import ImgUploaderIcon from "../../../../shared/Svg/ImgUploaderIcon";
import MediaUploaderModal from "../../../../shared/MediaUploaderModal";
import MediaSquareTag from "../../../shared/MediaSquareTag";

export default props => {
  const [text, setText] = useState("");
  const [media, setMedia] = useState([]);
  let setter = e => setText(e.target.value);
  let submitter = () =>
    (text || media.length > 0) &&
    props.onSubmitMessage(
      text,
      media.map(m => ({ id: m.id, type: m.type, url: m.url }))
    ) &&
    (setText("") || setMedia([]));
  let onEnter = e => e.key === "Enter" && submitter();
  let addMediaToMessage = medium => {
    setMedia([...media, medium]);
  };
  let removeMedium = medium => {
    setMedia(media.filter(m => m.id !== medium.id));
  };
  return (
    <div
      id="chat_input"
      className="d-flex flex-column justify-content-between"
      style={{ height: !media.length ? 67 : 120 }}
    >
      {!media.length ? null : (
        <div className="media-bar d-flex mb-2">
          {media.map(medium => (
            <MediaSquareTag className="mr-2" medium={medium} x={removeMedium} />
          ))}
        </div>
      )}
      <div className="d-flex justify-content-between">
        <MediaUploaderModal mediaUploaded={addMediaToMessage}>
          <div className="d-flex justify-content-around" style={{ flex: 1.5 }}>
            <MusicUploaderIcon color="#333333" />
            <VideoUploaderIcon color="#333333" />
            <ImgUploaderIcon color="#333333" />
          </div>
        </MediaUploaderModal>
        <div className="px-2" style={{ flex: 3.5 }}>
          <input
            value={text}
            onChange={setter}
            onKeyDown={onEnter}
            placeholder="Write a message"
            className="w-100 px-2"
          ></input>
        </div>
        <div style={{ flex: 1 }}>
          <button onClick={submitter} className="btn btn-primary w-100">
            Send
          </button>
        </div>
      </div>
    </div>
  );
};
